module.exports = __webpack_public_path__ + "img/help-content-2.a33bf3bd.png";